<template>
  <ul :class="bem()">
    <li
      v-for="(breadcrumb, idx) in breadcrumbs"
      :key="breadcrumb.target"
      :class="bem('breadcrumb', { active: breadcrumb.active })"
    >
      <NuxtLink
        :to="breadcrumb.target"
        :class="bem('target')"
      >
        <span>{{ breadcrumb.label }}</span>
      </NuxtLink>

      <VisionIcon
        v-if="idx < breadcrumbs.length - 1"
        :class="bem('icon')"
        icon="chevron"
        size="x-small"
        colour="black"
      />
    </li>
  </ul>
</template>

<script setup>
const bem = useBEM('SupportBreadcrumbs')

defineProps({
  breadcrumbs: { type: Array, required: true }
})
</script>

<style lang="postcss">
.SupportBreadcrumbs {
  @apply flex gap-x-2 items-center
    flex-wrap;

  &__breadcrumb {
    @apply flex items-center;

    &--active {
      @apply font-semibold;
    }
  }

  &__target {
    @apply line-clamp-1 truncate;
  }

  &__icon {
    @apply ml-2 transform scale-50;
  }
}
</style>